(function(){
    // tiny async helpers
    const wait = (ms) => new Promise(r => setTimeout(r, ms));
// double RAF to let Octane bind its handlers and set ARIA flags
    const raf2 = () => new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));

    function readSelectedIndexFromUL(ul) {
        if (!ul) return -1;
        const liList = Array.from(ul.children || []);
        const idx = liList.findIndex(li =>
            li.getAttribute('data-is-option-selected') === 'selected' ||
            li.getAttribute('aria-checked') === 'true' ||
            li.classList.contains('selected')
        );
        return idx;
    }

    async function ensureFirstSelectedForStep(quizWrap) {
        if (!quizWrap) return null;

        const ul = quizWrap.querySelector(
            '.oct-quiz-picture-choice-options, .oct-quiz-picture-choice-items, [data-element*="picture-choice-options"]'
        );
        if (!ul) return null;

        await raf2();
        const idx = readSelectedIndexFromUL(ul);
        if (idx < 0) {
            autoSelectFirstOption(ul, 0);
            await wait(30);
        }
        return ul;
    }

    function applyQuestionIdxClass(idx, detail) {
        if (!Number.isInteger(idx) || idx < 0) return;

        // a) внешний контейнер
        const outer =
            document.getElementById('octane-quiz-outer-wrapper') ||
            detail?.quiz_wrapper_element?.closest('#octane-quiz-outer-wrapper') ||
            document.querySelector('#octane-quiz-outer-wrapper');

        if (outer) {
            for (const cls of [...outer.classList]) {
                if (cls.startsWith('question-') && /^\d+$/.test(cls.slice('question-'.length))) {
                    outer.classList.remove(cls);
                }
            }
            outer.classList.add(`question-${idx}`);
            const qTitle = (detail?.question_title || '').trim();
            const qId    = detail?.question_id || '';
            if (qTitle) outer.setAttribute('data-question-title', qTitle);
            if (qId)    outer.setAttribute('data-question-id', qId);
        }


        const localWrap = detail?.quiz_wrapper_element || document.querySelector('.oct-quiz-wrapper');
        if (localWrap) {
            for (const cls of [...localWrap.classList]) {
                if (cls.startsWith('question-') && /^\d+$/.test(cls.slice('question-'.length))) {
                    localWrap.classList.remove(cls);
                }
            }
            localWrap.classList.add(`question-${idx}`);
        }
    }


    const IMG_WRAP_CLASS = 'oct-img-wrapper';

    function wrapImagesIn(scope) {
        const root = scope || document.querySelector('.oct-quiz-wrapper');
        if (!root) return;

        const items = root.querySelectorAll('.oct-quiz-picture-choice-options li, li');
        items.forEach((li) => {
            const imgEl = li.querySelector('[role="img"]');
            if (!imgEl) return;
            if (imgEl.parentElement && imgEl.parentElement.classList.contains(IMG_WRAP_CLASS)) return;

            const wrap = document.createElement('div');
            wrap.className = IMG_WRAP_CLASS;
            imgEl.parentNode.insertBefore(wrap, imgEl);
            wrap.appendChild(imgEl);
        });
    }

    function maybeWrapForQuestion0(detail) {
        const idx = Number.isInteger(detail?.idx) ? detail.idx : null;
        const quizWrap = detail?.quiz_wrapper_element || document.querySelector('.oct-quiz-wrapper');
        if (!quizWrap) return;

        if (idx === 0 && quizWrap.dataset.q0Wrapped !== '1') {
            wrapImagesIn(quizWrap);
            quizWrap.dataset.q0Wrapped = '1';
            // console.log('[quiz] wrapped [role="image"] for question 0');
        }
    }

    // ---------- Swiper for shades on Q0 ----------
    if (typeof ensureSwiper !== 'function') {
        window.ensureSwiper = async function ensureSwiper(){
            const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
            const SWIPER_JS  = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';

            if (!document.querySelector('link[data-oct-swiper]')){
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = SWIPER_CSS;
                link.setAttribute('data-oct-swiper','1');
                document.head.appendChild(link);
            }
            if (!window.Swiper){
                await new Promise((res, rej)=>{
                    const s = document.createElement('script');
                    s.src = SWIPER_JS; s.async = true; s.onload = res; s.onerror = rej;
                    document.head.appendChild(s);
                });
            }
        };
    }

    function centerMainByIndex(ul, idx){
        const container = ul?.closest('.oct-quiz-picture-choice-wrapper');
        if (!container) return;
        const li = ul.children?.[idx];
        if (!li) return;

        const target = li.offsetLeft + li.offsetWidth/2 - container.clientWidth/2;
        const clamped = Math.max(0, Math.min(target, container.scrollWidth - container.clientWidth));
        container.scrollTo({ left: clamped, behavior: 'smooth' });
    }


    // ===== Shade Swiper (Q0) – STRICTLY BEFORE the Next button; centers top row on every interaction
    async function buildShadeSwiper(quizWrap, ul){
        // --- debug helpers ---
        const log     = (...a) => (window.OCT_DEBUG ?? true) && console.log('[shade]', ...a);
        const warn    = (...a) => (window.OCT_DEBUG ?? true) && console.warn('[shade]', ...a);
        const group   = (t='buildShadeSwiper') => (console.groupCollapsed ? console.groupCollapsed(t) : void 0);
        const groupEnd= () => (console.groupEnd ? console.groupEnd() : void 0);

        // --- guards ---
        if (!quizWrap || !ul) { warn('no quizWrap or ul'); return; }
        if (quizWrap.querySelector('.oct-shade-swiper')) { log('already exists'); return; }

        // --- local helpers ---

        // 1) Находим "корень кнопок" (тот предок, в котором действительно лежит NEXT)
        function getButtonsRoot(qw){
            const hasButtons = (node) => !!node?.querySelector(
                '.oct-quiz-btn-wrapper, .oct-quiz-buttons, .oct-quiz-footer, [data-element*="oct-quiz-btn"], [data-element*="oct-quiz-buttons"]'
            );

            const outer = qw.closest('#octane-quiz-outer-wrapper') || qw.closest('.oct-quiz-wrapper') || document.body;

            let n = qw;
            while (n && n !== outer.parentElement){
                if (hasButtons(n)) return n;
                n = n.parentElement;
            }

            if (hasButtons(outer)) return outer;

            let p = qw.parentElement;
            while (p && p !== document.body){
                if (hasButtons(p)) return p;
                p = p.parentElement;
            }
            return outer;
        }

        function findNextBtn(root){
            const candidates = [
                '[data-element*="oct-quiz-next"]',
                '.oct-quiz-btn[aria-label="Next"]',
                '.oct-quiz-btn[title="next" i]',
                '.oct-quiz-btn.oct-quiz-btn--primary:not([title="back" i]):not([aria-label="Back" i])',
                'button.oct-quiz-btn--primary:not([title="back" i])',
                'a.oct-quiz-btn--primary:not([title="back" i])'
            ];
            const scopes = [
                root.querySelector('.oct-quiz-btn-wrapper, .oct-quiz-buttons, .oct-quiz-footer, [data-element*="oct-quiz-btn"], [data-element*="oct-quiz-buttons"]'),
                root
            ].filter(Boolean);

            for (const scope of scopes){
                for (const sel of candidates){
                    const btn = scope.querySelector(sel);
                    if (btn) return btn;
                }
            }
            const all = root.querySelectorAll('.oct-quiz-btn, button, a');
            return all.length ? all[all.length - 1] : null;
        }

        function getScrollContainer(ul){
            const pref = ul.closest('.oct-quiz-picture-choice-wrapper');
            const list = [pref, ul, ul.parentElement, pref?.parentElement].filter(Boolean);
            const looksScrollable = (el) => {
                const cs = getComputedStyle(el);
                return /auto|scroll/i.test(cs.overflowX) || (el.scrollWidth - el.clientWidth > 5);
            };
            for (const el of list){
                if (looksScrollable(el)) return el;
            }

            let p = ul.parentElement;
            while (p && p !== document.body){
                if (looksScrollable(p)) return p;
                p = p.parentElement;
            }
            return pref || ul;
        }

        function offsetLeftRelTo(el, ancestor){
            let x = 0, n = el;
            while (n && n !== ancestor){
                x += n.offsetLeft;
                n = n.offsetParent;
            }
            return x;
        }

        function simulateClick(el){
            ['pointerdown','mousedown','mouseup','click'].forEach(type =>
                el.dispatchEvent(new MouseEvent(type, { bubbles:true, cancelable:true, view:window }))
            );
        }

        function centerTopByIndex(idx){
            const scroller = getScrollContainer(ul);
            const li = ul.children?.[idx];
            if (!scroller || !li) return;
            const leftWithinScroller =
                (scroller === ul) ? li.offsetLeft : offsetLeftRelTo(li, scroller);
            const target = leftWithinScroller + (li.offsetWidth/2) - (scroller.clientWidth/2);
            const maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
            const clamped = Math.max(0, Math.min(target, maxLeft));
            scroller.scrollTo({ left: clamped, behavior: 'smooth' });
        }

        const liEls = Array.from(ul.querySelectorAll('li'));
        if (!liEls.length) { warn('no LI options'); return; }

        const labels = liEls.map(li => {
            const img = li.querySelector('[role="img"], [role="image"]');
            return (
                img?.getAttribute('aria-label') ||
                li.querySelector('.oct-quiz-caption-text')?.textContent ||
                li.textContent || ''
            ).trim();
        });

        group('buildShadeSwiper');
        const slider = document.createElement('div');
        slider.className = 'oct-shade-swiper swiper';
        slider.innerHTML = `
    <div class="swiper-wrapper"></div>
    <div class="swiper-button-prev" aria-label="Previous"></div>
    <div class="swiper-button-next" aria-label="Next"></div>
  `;

        const buttonsRoot = getButtonsRoot(quizWrap);
        const nextBtn = findNextBtn(buttonsRoot);
        const btnWrap = buttonsRoot.querySelector('.oct-quiz-btn-wrapper, .oct-quiz-buttons, .oct-quiz-footer, [data-element*="oct-quiz-btn"], [data-element*="oct-quiz-buttons"]');

        log('buttonsRoot=', buttonsRoot, 'nextBtn?', !!nextBtn, 'btnWrap?', !!btnWrap, 'opts:', liEls.length);

        if (nextBtn && nextBtn.parentNode){
            nextBtn.parentNode.insertBefore(slider, nextBtn);
            log('slider inserted BEFORE NEXT');
        } else if (btnWrap && btnWrap.parentNode){
            btnWrap.parentNode.insertBefore(slider, btnWrap);
            warn('NEXT not found; inserted before buttons wrapper (fallback#1)');
        } else {
            ul.insertAdjacentElement('afterend', slider);
            warn('NEXT/wrapper not found; inserted after UL (fallback#2)');
        }

        const wrap = slider.querySelector('.swiper-wrapper');
        labels.forEach((t, i) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.innerHTML = `
      <button type="button" class="oct-swatch" data-index="${i}">
        <span class="oct-swatch__label">${t || `Option ${i + 1}`}</span>
      </button>
    `;
            wrap.appendChild(slide);
        });
        const swatches = slider.querySelectorAll('.oct-swatch');
        if (swatches[0]) swatches[0].classList.add('oct-swatch--left');
        if (swatches.length > 1) swatches[swatches.length - 1].classList.add('oct-swatch--right');


        try {
            await ensureSwiper();
        } catch (err) {
            groupEnd(); warn('ensureSwiper failed:', err); return;
        }
        log('Swiper present?', !!window.Swiper);


        const prevEl = slider.querySelector('.swiper-button-prev');
        const nextEl = slider.querySelector('.swiper-button-next');
        const count  = labels.length;

        const swiper = new Swiper(slider, {
            slidesPerView: Math.min(count, 5),
            spaceBetween: 8,
            allowTouchMove: true,
            watchOverflow: true,
            navigation: { nextEl, prevEl }
        });
        log('swiper init; spv=', Math.min(count, 5));


        const readSelectedIndex = () =>
            liEls.findIndex(li =>
                li.getAttribute('aria-checked') === 'true' ||
                li.getAttribute('data-is-option-selected') === 'selected' ||
                li.classList.contains('selected')
            );

        const setActive = (i) => {
            slider.querySelectorAll('.oct-swatch').forEach((b, idx)=>{
                b.classList.toggle('is-active', idx === i);
            });
        };

        let activeIndex = Math.max(0, readSelectedIndex());
        log('activeIndex (init)=', activeIndex);
        setActive(activeIndex);
        swiper.slideTo(activeIndex, 0);

        requestAnimationFrame(() => centerTopByIndex(activeIndex));

        const updateNavState = () => {
            const atStart = activeIndex <= 0;
            const atEnd   = activeIndex >= count - 1;
            prevEl.toggleAttribute('disabled', atStart);
            nextEl.toggleAttribute('disabled', atEnd);
            prevEl.classList.toggle('swiper-button-disabled', atStart);
            nextEl.classList.toggle('swiper-button-disabled', atEnd);
            prevEl.setAttribute('aria-disabled', String(atStart));
            nextEl.setAttribute('aria-disabled', String(atEnd));
        };
        updateNavState();

        slider.addEventListener('click', (ev) => {
            const btn = ev.target.closest('.oct-swatch');
            if (!btn) return;
            const i = +btn.dataset.index;
            if (i === activeIndex) return;
            log('bottom click →', i);
            activeIndex = i;
            simulateClick(liEls[i]);
            setActive(i);
            swiper.slideTo(i, 150);
            requestAnimationFrame(() => centerTopByIndex(i));
            updateNavState();
        });

        // --- arrows ---
        prevEl.addEventListener('click', () => {
            if (activeIndex <= 0) return;
            activeIndex -= 1;
            log('nav prev →', activeIndex);
            simulateClick(liEls[activeIndex]);
            setActive(activeIndex);
            swiper.slideTo(activeIndex, 150);
            requestAnimationFrame(() => centerTopByIndex(activeIndex));
            updateNavState();
        });

        nextEl.addEventListener('click', () => {
            if (activeIndex >= count - 1) return;
            activeIndex += 1;
            log('nav next →', activeIndex);
            simulateClick(liEls[activeIndex]);
            setActive(activeIndex);
            swiper.slideTo(activeIndex, 150);
            requestAnimationFrame(() => centerTopByIndex(activeIndex));
            updateNavState();
        });


        const handleTopActivate = (li) => {
            const curr = Array.from(ul.querySelectorAll('li'));
            const i = curr.indexOf(li);
            if (i < 0 || i === activeIndex) return;
            log('top activate →', i);
            activeIndex = i;
            setActive(i);
            swiper.slideTo(i, 150);
            requestAnimationFrame(() => centerTopByIndex(i));
            updateNavState();
        };

        ul.addEventListener('click', (ev) => {
            const li = ev.target.closest('li');
            if (!li) return;
            handleTopActivate(li);
        });

        ul.addEventListener('keydown', (ev) => {
            if (ev.key !== 'Enter' && ev.key !== ' ') return;
            const li = ev.target.closest('li');
            if (!li) return;
            handleTopActivate(li);
        });

        // --- mutation fallback ---
        const obs = new MutationObserver(() => {
            const si = readSelectedIndex();
            if (si >= 0 && si !== activeIndex) {
                log('mutation sync →', si);
                activeIndex = si;
                setActive(si);
                swiper.slideTo(si, 150);
                requestAnimationFrame(() => centerTopByIndex(si));
                updateNavState();
            }
        });
        obs.observe(ul, { subtree:true, attributes:true, attributeFilter:['class','aria-checked','data-is-option-selected'] });

        groupEnd();
        return slider;
    }

    // --- Q3: sanitize subheading (< > ( )) --------------------------------------
    function sanitizeQ3Subheading(quizWrap){
        if (!quizWrap) return;
        const el = quizWrap.querySelector('.oct-quiz-subheading');
        if (!el) return;

        const before = el.textContent || '';
        const after  = before.replace(/[<>()]/g, '').replace(/\s{2,}/g, ' ').trim();
        if (after !== before) el.textContent = after;
    }


    function injectCenteredTitlesForQ2(quizWrap){
        const ul = quizWrap.querySelector('.oct-quiz-picture-choice-options');
        if (!ul) return;

        ul.querySelectorAll('li.oct-quiz-picture-choice-options__option').forEach(li => {
            if (li.dataset.titleInjected === '1') return;

            const img = li.querySelector('[role="img"], [role="image"]');
            const title =
                img?.getAttribute('aria-label') ||
                li.getAttribute('title') ||
                '';

            if (!title) return;

            const el = document.createElement('div');
            el.className = 'oct-q2-title';
            el.textContent = title;

            if (img) {
                img.insertAdjacentElement('afterend', el);
            } else {
                li.appendChild(el);
            }

            li.dataset.titleInjected = '1';
        });
    }

    /* ===== Answer descriptions: tiny helpers ===== */

    // ---------- Answer panel ----------
    let __octAnswerBank = null;

    function ensureAnswerBank() {
        if (__octAnswerBank) return __octAnswerBank;

        const map = new Map();
        const nodes = document.querySelectorAll('#oct-answer-bank .oct-answer-data');
        nodes.forEach((el) => {
            const qId   = (el.dataset.question || '').trim();
            const qIdx  = (el.dataset.questionIdx || '').trim();
            const opt   = (el.dataset.option || '').trim().toLowerCase();
            const title = el.dataset.title || '';

            const bodyNode = el.querySelector('.oct-answer-html');
            const bodyHtml = bodyNode ? bodyNode.innerHTML : el.innerHTML;

            if (qId)  map.set(`${qId}::${opt}`, { title, bodyHtml });
            if (qIdx) map.set(`byIdx:${qIdx}::${opt}`, { title, bodyHtml });
        });

        __octAnswerBank = map;
        return map;
    }

    function ensureAnswerPanelAfterUL(ul) {
        if (!ul) return null;
        const wrap = ul.parentElement;
        let panel = wrap.querySelector(':scope > .oct-answer-panel');

        if (!panel) {
            panel = document.createElement('div');
            panel.className = 'oct-answer-panel';
            panel.setAttribute('aria-live', 'polite');
        }
        if (ul.nextElementSibling !== panel) {
            ul.insertAdjacentElement('afterend', panel);
        }
        return panel;
    }

    function updateAnswerPanel(quizWrap, detail) {
        const bank = ensureAnswerBank();
        const ul = quizWrap.querySelector('.oct-quiz-picture-choice-options');
        if (!ul) return;

        const panel = ensureAnswerPanelAfterUL(ul);
        if (!panel) return;

        const li =
            ul.querySelector('[data-is-option-selected="selected"]') ||
            ul.querySelector('[aria-checked="true"]') ||
            ul.querySelector('.selected');

        if (!li) { panel.innerHTML = ''; return; }

        const img = li.querySelector('[role="img"], [role="image"]');
        const opt = (
            img?.getAttribute('aria-label') ||
            li.getAttribute('title') ||
            li.textContent ||
            ''
        ).trim().toLowerCase();

        const k1 = detail?.question_id ? `${detail.question_id}::${opt}` : '';
        const k2 = Number.isInteger(detail?.idx) ? `byIdx:${detail.idx}::${opt}` : '';
        const data = bank.get(k1) || (k2 ? bank.get(k2) : null);

        if (!data) { panel.innerHTML = ''; return; }

        const titleHtml = data.title ? `<h4 class="oct-answer-title">${data.title}</h4>` : '';
        panel.innerHTML = `${titleHtml}${data.bodyHtml || ''}`;
    }

    function hookAnswerSync(ul, detail, quizWrap) {
        if (!ul || ul.dataset.answerHooked === '1') return;
        const refresh = () => updateAnswerPanel(quizWrap, detail);
        ul.addEventListener('click', () => setTimeout(refresh, 0), true);
        ul.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter' || ev.key === ' ') setTimeout(refresh, 0);
        }, true);
        ul.dataset.answerHooked = '1';
    }

    function autoSelectFirstOption(ul, preferIdx = 0){
        if (!ul) return -1;

        const already = ul.querySelector(
            '[data-is-option-selected="selected"], [aria-checked="true"], .selected'
        );
        if (already) {
            const li = already.closest('li') || already;
            return Array.from(ul.children).indexOf(li);
        }

        const li =
            ul.querySelector(`li[data-option-index="${preferIdx}"]`) ||
            ul.querySelector('li');
        if (!li) return -1;

        ['pointerdown','mousedown','mouseup','click'].forEach(type =>
            li.dispatchEvent(new MouseEvent(type, { bubbles:true, cancelable:true, view:window }))
        );

        return Array.from(ul.children).indexOf(li);
    }

    // ---------- small UX helper ----------
    let locking = false;
    function lockScroll(ms = 500) {
        if (locking) return;
        locking = true;

        const y = window.pageYOffset || document.documentElement.scrollTop || 0;
        const root = document.documentElement;
        const prevBehavior = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';

        let frames = 8;
        function hold() {
            window.scrollTo(0, y);
            if (--frames > 0) requestAnimationFrame(hold);
            else {
                root.style.scrollBehavior = prevBehavior;
                locking = false;
            }
        }
        hold();

        setTimeout(() => {
            root.style.scrollBehavior = prevBehavior;
            locking = false;
        }, ms);
    }

    // ---------- Stepper state (local to this file) ----------
    let steps = [];
    const byKey = new Map();
    let resultsAdded = false;
    let list;
    let activeIdx = -1;

    const norm  = s => (s || '').trim();
    const keyOf = (id, title) => (id && String(id).length > 8 ? String(id) : norm(title).toLowerCase()) || '';
    const label = (title, fallback) => norm(title) || fallback;

    function layout(){
        if (!list) return;
        const items = list.querySelectorAll('.oct-step');
        const n = items.length;
        items.forEach((li,i)=>{
            const pct = n <= 1 ? 0 : (i / (n - 1)) * 100;
            li.style.left = pct + '%';
        });
    }

    function render(){
        if (!list) return;
        list.innerHTML = '';
        steps.forEach((s,i)=>{
            const li = document.createElement('li');
            li.className = 'oct-step';
            li.dataset.index = i;
            li.innerHTML = `
        <span class="oct-step__dot" aria-hidden="true"></span>
        <span class="oct-step__label">${label(s.title, `Step ${i+1}`)}</span>
      `;
            list.appendChild(li);
        });
        layout();
        // после перерисовки стоит восстановить активный визуально
        if (activeIdx >= 0) setActive(activeIdx);
    }

    function setActive(idx){
        activeIdx = idx; // <— фиксируем текущую позицию
        if (!list) return;
        const items = list.querySelectorAll('.oct-step');
        items.forEach((li,i)=>{
            li.classList.toggle('is-active', i === idx);
            li.classList.toggle('is-done',   i < idx);
        });
    }

    function rebuildByKey(){
        byKey.clear();
        steps.forEach((s,i)=> byKey.set(s.key, i));
    }

    function ensureStep(id, title){
        const k = keyOf(id, title);
        if (!k){ /* console.log('[stepper] skip empty key', {id, title}); */ return null; }

        if (byKey.has(k)) {
            const existing = byKey.get(k);
            // если прыгаем назад — обрезаем хвост UI-маршрута
            if (existing < steps.length - 1) {
                steps = steps.slice(0, existing + 1);
                rebuildByKey();
                render();
            }
            return existing;
        }

        // если после возврата выбираем новый путь — обрезаем хвост
        if (activeIdx >= 0 && activeIdx < steps.length - 1) {
            steps = steps.slice(0, activeIdx + 1);
            rebuildByKey();
            render();
        }

        const idx = steps.push({ key: k, title: title || '' }) - 1;
        byKey.set(k, idx);
        render();
        return idx;
    }

    function ensureResults(){
        if (resultsAdded) return;
        resultsAdded = true;
        steps.push({ key: '__results__', title: 'Results' });
        rebuildByKey();
        render();
    }

    function init(){
        // Если файл в assets — ищем по классу
        const root =
            document.getElementById('oct-stepper-{{ section.id }}') ||
            document.querySelector('.oct-stepper');

        if (!root){ /* console.log('[stepper] root not found yet'); */ return; }
        list = root.querySelector('.oct-stepper__list');
        if (!list){ /* console.log('[stepper] list not found'); */ return; }

        setTimeout(() => {
            if (steps.length > 0) return; // не дублируем первый шаг
            const liveTitle = document.querySelector('[data-element~="oct-quiz-title"], .oct-quiz-title')?.textContent?.trim();
            if (liveTitle) {
                const idx = ensureStep('', liveTitle);
                if (idx !== null) setActive(idx);
            }
        }, 300);
    }

    if (document.readyState === 'loading'){
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // ---------- Events ----------
    document.addEventListener('octane.quiz.questionLoaded', async (e) => {
        const d = e.detail || {};
        lockScroll(600);

        const idxFromEnsure = ensureStep(d.question_id, d.question_title);
        const classIdx = Number.isInteger(d.idx) ? d.idx : idxFromEnsure;

        if (idxFromEnsure !== null) setActive(idxFromEnsure);
        if (classIdx !== null) applyQuestionIdxClass(classIdx, d);

        maybeWrapForQuestion0(d);

        const quizWrap =
            d.quiz_wrapper_element ||
            document.querySelector('#octane-quiz-outer-wrapper .oct-quiz-wrapper') ||
            document.querySelector('.oct-quiz-wrapper');
        if (!quizWrap) return;

        if (classIdx === 3) {
            sanitizeQ3Subheading(quizWrap);
        }

        const ul = await ensureFirstSelectedForStep(quizWrap);

        if (classIdx === 0 && ul) {
            await buildShadeSwiper(quizWrap, ul);
            const si = readSelectedIndexFromUL(ul);
            if (si >= 0) requestAnimationFrame(() => centerMainByIndex(ul, si));
            ensureAnswerPanelAfterUL(ul);
            hookAnswerSync(ul, d, quizWrap);
            updateAnswerPanel(quizWrap, d);
        } else if (ul) {
            const si = readSelectedIndexFromUL(ul);
            if (si >= 0) requestAnimationFrame(() => centerMainByIndex(ul, si));
            ensureAnswerPanelAfterUL(ul);
            hookAnswerSync(ul, d, quizWrap);
            updateAnswerPanel(quizWrap, d);
        }

        if (classIdx === 2) {
            requestAnimationFrame(() => injectCenteredTitlesForQ2(quizWrap));
        }
    });

    document.addEventListener('octane.quiz.completed', (e) => {
        ensureResults();
        setActive(steps.length - 1);
        applyQuestionIdxClass(steps.length - 1, e.detail || {});
    });

    setTimeout(() => {
        if (typeof steps !== 'undefined' && steps.length > 0) return;
        const liveTitle = document.querySelector('[data-element~="oct-quiz-title"], .oct-quiz-title')?.textContent?.trim();
        if (liveTitle) {
            const idxFromEnsure = ensureStep('', liveTitle);
            if (idxFromEnsure !== null) {
                setActive(idxFromEnsure);
                applyQuestionIdxClass(idxFromEnsure, {});
            }
        }
    }, 300);
})();
